import { render, staticRenderFns } from "./PriorityBadge.vue?vue&type=template&id=6d8497d1&"
import script from "./PriorityBadge.vue?vue&type=script&lang=js&"
export * from "./PriorityBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports